import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=7ae96b2e&scoped=true"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"
import style0 from "./IndexPage.vue?vue&type=style&index=0&id=7ae96b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae96b2e",
  null
  
)

export default component.exports